import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	emptyText: {
		id: 'atlassian-navigation.dashboards.menu.empty.empty-text',
		defaultMessage: 'Create a dashboard to track the status of your projects.',
		description: 'Suggest an action to the user',
	},
	learnMore: {
		id: 'atlassian-navigation.dashboards.menu.empty.learn-more',
		defaultMessage: 'More about dashboards',
		description: 'Suggest user click on the link to learn more about dashboards in jira',
	},
	emptyImg: {
		id: 'atlassian-navigation.dashboards.menu.empty.empty-img',
		defaultMessage: 'An image showing that the apps dropdown menu is empty',
		description: 'Alt text for empty view',
	},
});
